import { Component, Inject, OnInit, Optional } from '@angular/core'
import { CreateNewPatientModalService } from './create-new-patient-modal.service'
import { ToastrModule, ToastrService } from 'ngx-toastr'
import {
    MatDialogRef,
    MAT_DIALOG_DATA,
    MatDialog,
} from '@angular/material/dialog'
import * as moment from 'moment'
import { CommonModule } from '@angular/common'
import { MatSelectModule } from '@angular/material/select'
import { FormsModule } from '@angular/forms'
import { DisallowSpacesDirective } from '../../../../directive/disallow-spaces.directive'
import { MatInputModule } from '@angular/material/input'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import {
    checkExternalIdExistsOrNot,
    checkExternalIdExistsPayload,
    createNewPatient,
    months,
} from './create-new-patient-interfaces'
import { NgSelectModule } from '@ng-select/ng-select'
import { InboxService } from '../../inbox/inbox.service'
import { PatientDetailMergeModalComponent } from '../patient-details-merge-modal/patient-detail-merge-modal.component'
export interface phoneNumbers {
    phoneNumber: string
    type: string
}
export interface emailAddresses {
    email: string
    type: string
}
export interface patientInfo {
    isIndividual: boolean
    type: string
    displayName: string
    firstName: string
    middleName?: string
    lastName: string
    dateOfBirth: string
    birthGender: string
    externalId: string
    homePhone: string
    cellPhone: string
    phoneNumbers: phoneNumbers[]
    emailAddresses: emailAddresses[]
    address?: addressObject
}
export interface patientInformationObject {
    patientInfo: patientInfo
}

export interface addressObject {
    addressLine1: string
    addressLine2: string
    city: string
    postalCode: string
    stateOrProvinceCode: string
}
export interface DateOfBirthObject {
    dateOfBirth: string
    dobMonth: number | null
    dobYear: string
    dobDay: number | null
}
@Component({
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ToastrModule,
        MatSelectModule,
        DisallowSpacesDirective,
        MatInputModule,
        MatAutocompleteModule,
        NgSelectModule,
    ],
    selector: 'app-create-new-patient-modal',
    templateUrl: './create-new-patient-modal.component.html',
    styleUrls: ['./create-new-patient-modal.component.css'],
})
export class CreateNewPatientModalComponent implements OnInit {
    genderArr: string[] = ['Male', 'Female']
    __temporaryPassword: number | null = null
    isValid: boolean = true
    emailRegex: RegExp = /^[\S]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    nameRegex: RegExp = /^[A-Za-z0-9 ]+$/
    phoneRegex: RegExp = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/
    deformatPhoneRegex: RegExp = /[^A-Za-z0-9]+/g
    tempPhone: string = ''
    email: string = ''
    loader: boolean = false
    checkExternalIdExistsOrNot: checkExternalIdExistsOrNot = {
        data: {
            isSameOrgEntity: false,
            isExternalIdAlreadyPresent: false,
            newOrgEntityId: '',
            isNew: false,
        },
        isActionSuccess: false,
    }
    createNewPatientResult: createNewPatient = {
        data: {
            isIndividual: false,
            type: '',
            displayName: '',
            firstName: '',
            lastName: '',
            dateOfBirth: '',
            birthGender: '',
            externalId: '',
            phoneNumbers: [
                {
                    phoneId: '',
                    phoneNumber: '',
                    isPrimary: false,
                    type: '',
                    isReserved: false,
                    isVoiceNumber: false,
                    isSmsNumber: false,
                },
            ],
            emailAddresses: [
                {
                    emailId: '',
                    email: '',
                    type: '',
                    isPrimary: false,
                    isReserved: false,
                },
            ],
            orgEntityId: '',
        },
        isAlreadyPresent: false,
    }
    patientInformationObject: patientInformationObject = {
        patientInfo: {
            isIndividual: true,
            type: 'PATIENT',
            displayName: '',
            firstName: '',
            lastName: '',
            dateOfBirth: '',
            birthGender: '',
            externalId: '',
            homePhone: '',
            cellPhone: '',
            phoneNumbers: [
                {
                    phoneNumber: '',
                    type: 'CELL',
                },
            ],
            emailAddresses: [
                {
                    email: '',
                    type: 'HOME',
                },
            ],
            address: {
                addressLine1: '',
                addressLine2: '',
                city: '',
                postalCode: '',
                stateOrProvinceCode: null,
            },
        },
    }
    dateOfBirthObject: DateOfBirthObject = {
        dateOfBirth: '',
        dobMonth: null,
        dobYear: '',
        dobDay: null,
    }
    constructor(
        public createNewPatientService: CreateNewPatientModalService,
        private toastr: ToastrService,
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<CreateNewPatientModalService>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            showBackToSearch: boolean
            patientDetails: any
            editPatient: boolean
            stateList: any[]
            orgEntityId?: string
        },
    ) {}
    day: string = ''
    days: string[] = []
    months = months
    setDays() {
        for (let j = 0; j < this.months.length; j++) {
            if (
                this.months[j].id == this.dateOfBirthObject.dobMonth?.toString()
            ) {
                this.days = [] // Reset days array before adding new days
                for (let i = 1; i <= this.months[j].maxDays; i++) {
                    if (i < 10) {
                        this.day = '0' + i
                        this.days.push(this.day.toString())
                    } else {
                        this.days.push(i.toString())
                    }
                }
            }
        }
    }
    checkNumber(event: any) {
        /**check the value of the keyPress to make sure it's a num. which from 48-57 are 0-9 */
        if ((event.which !== 8 && event.which < 48) || event.which > 57) {
            event.preventDefault()
        }
    }

    checkIfDateOfBirthIsGreaterThanCurrentDate(enteredDateOfBirth: any) {
        enteredDateOfBirth = new Date(enteredDateOfBirth)
        enteredDateOfBirth.setHours(0, 0, 0, 0)
        var currentDate = new Date()
        currentDate.setHours(0, 0, 0, 0)
        return enteredDateOfBirth >= currentDate
    }
    closeModal() {
        this.dialogRef.close({ goBackToSearch: false })
    }
    monthName(value1: string) {
        if (value1) {
            if (this.months?.find((month) => month.id === value1)) {
                return this.months?.find((month) => month.id === value1)
                    ?.displayName
            }
        }
        return null
    }
    removeAllSpace() {
        setTimeout(() => {
            this.patientInformationObject.patientInfo.externalId =
                this.patientInformationObject.patientInfo.externalId.replaceAll(
                    /\s/g,
                    '',
                )
        }, 0)
    }
    validatePatientInfoExtendedInfo() {
        this.isValid = true
        let isLeapYear =
            parseInt(this.dateOfBirthObject.dobYear) % 100 === 0
                ? parseInt(this.dateOfBirthObject.dobYear) % 400 === 0
                : parseInt(this.dateOfBirthObject.dobYear) % 4 === 0
        if (
            this.patientInformationObject.patientInfo &&
            !this.patientInformationObject.patientInfo.externalId.trim()
        ) {
            this.toastr.warning(`Please enter external Id`)
            this.isValid = false
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.externalId.length > 100
        ) {
            this.toastr.warning(
                `External Id should be less than 100 characters`,
            )
            this.isValid = false
        } else if (
            this.patientInformationObject.patientInfo &&
            !this.patientInformationObject.patientInfo.firstName.trim()
        ) {
            this.toastr.warning(`Please enter First Name`)
            this.isValid = false
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.firstName.length > 60
        ) {
            this.toastr.warning(`First name should be less than 60 characters`)
            this.isValid = false
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.lastName.length > 60
        ) {
            this.toastr.warning(`Last name should be less than 60 characters`)
            this.isValid = false
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.firstName.trim() &&
            !this.nameRegex.test(
                this.patientInformationObject.patientInfo.firstName,
            )
        ) {
            this.toastr.warning(`Please enter valid First Name`)
            this.isValid = false
        } else if (
            this.patientInformationObject.patientInfo &&
            !this.patientInformationObject.patientInfo.lastName.trim()
        ) {
            this.toastr.warning(`Please enter Last Name`)
            this.isValid = false
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.lastName.trim() &&
            !this.nameRegex.test(
                this.patientInformationObject.patientInfo.lastName,
            )
        ) {
            this.toastr.warning(`Please enter valid Last Name`)
            this.isValid = false
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.phoneNumbers[0]
                .phoneNumber &&
            (this.patientInformationObject.patientInfo.phoneNumbers[0]
                .phoneNumber.length !== 15 ||
                !this.phoneRegex.test(
                    this.patientInformationObject.patientInfo.phoneNumbers[0]
                        .phoneNumber,
                ))
        ) {
            this.toastr.warning(`Please enter valid Phone Number`)
            this.isValid = false
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.emailAddresses[0] &&
            this.patientInformationObject.patientInfo.emailAddresses[0].email &&
            !this.emailRegex.test(
                this.patientInformationObject.patientInfo.emailAddresses[0]
                    .email,
            )
        ) {
            // if (!this.emailRegex.test(this.patientInformationObject.patientInfo.emailAddresses[0].email)) {
            this.toastr.warning(`Enter a valid Confidential Email`)
            this.isValid = false
            // }
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.emailAddresses[0].email
                .length > 100
        ) {
            this.toastr.warning(
                `Email address should be less than 100 characters`,
            )
            this.isValid = false
        } else if (
            this.patientInformationObject.patientInfo &&
            !this.patientInformationObject.patientInfo.birthGender
        ) {
            this.toastr.warning(`Please enter your  Gender`)
            this.isValid = false
        } else if (this.dateOfBirthObject && !this.dateOfBirthObject.dobMonth) {
            this.toastr.warning(`Please enter your  DOB Month`)
            this.isValid = false
        } else if (this.dateOfBirthObject && !this.dateOfBirthObject.dobDay) {
            this.toastr.warning(`Please enter your  DOB Day`)
            this.isValid = false
        } else if (this.dateOfBirthObject && !this.dateOfBirthObject.dobYear) {
            this.toastr.warning(`Please enter your  DOB Year`)
            this.isValid = false
        } else if (
            this.isValid &&
            this.dateOfBirthObject.dobMonth &&
            this.dateOfBirthObject.dobDay &&
            this.dateOfBirthObject.dobYear
        ) {
            if (
                this.dateOfBirthObject.dobMonth < 10 &&
                this.dateOfBirthObject.dobDay >= 10
            ) {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`
            } else if (
                this.dateOfBirthObject.dobDay < 10 &&
                this.dateOfBirthObject.dobMonth >= 10
            ) {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`
            } else if (
                this.dateOfBirthObject.dobDay < 10 &&
                this.dateOfBirthObject.dobMonth < 10
            ) {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`
            } else {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`
            }
            var date = moment(
                this.patientInformationObject.patientInfo.dateOfBirth,
            )
            if (date.isValid()) {
                var currentDateTime = new Date()
                var expirationDateTime = new Date(
                    this.patientInformationObject.patientInfo.dateOfBirth,
                )
                if (expirationDateTime.getTime() > new Date().getTime()) {
                    this.toastr.warning(
                        "Birth date can't be greater than or equal to the current date",
                    )
                    this.isValid = false
                } else if (+this.dateOfBirthObject.dobYear < 1900) {
                    this.toastr.warning(
                        'Birth year should be greater than or equal to 1900.',
                    )
                    this.isValid = false
                } else if (
                    expirationDateTime.getMonth() ===
                        currentDateTime.getMonth() &&
                    expirationDateTime.getFullYear() ===
                        currentDateTime.getFullYear() &&
                    expirationDateTime.getDate() === currentDateTime.getDate()
                ) {
                    this.toastr.warning(
                        "Birth date can't be greater than or equal to the current date",
                    )
                    this.isValid = false
                } else if (
                    this.dateOfBirthObject.dobMonth.toString() == '02' &&
                    this.dateOfBirthObject.dobDay > 28 &&
                    !isLeapYear
                ) {
                    this.toastr.warning('Invalid birth date')
                    this.isValid = false
                } else {
                    this.isValid = true
                }
            } else {
                this.toastr.warning('Date of birth is invalid')
                this.isValid = false
            }
        }

        return this.isValid
    }
    formatNumber() {
        this.formatPhoneNumberAndValidate()
    }
    formatPhoneNumberAndValidate() {
        this.patientInformationObject.patientInfo.homePhone =
            this.cleanPhoneNumber(
                this.patientInformationObject.patientInfo.homePhone,
            )
        this.patientInformationObject.patientInfo.cellPhone =
            this.cleanPhoneNumber(
                this.patientInformationObject.patientInfo.cellPhone,
            )
        this.patientInformationObject.patientInfo.phoneNumbers[0].phoneNumber =
            this.cleanPhoneNumber(
                this.patientInformationObject.patientInfo.phoneNumbers[0]
                    .phoneNumber,
            )
    }
    filterPhoneNumber = (phoneNumber: string) => {
        if (!phoneNumber) {
            return ''
        }
        var value = phoneNumber.toString().trim().replace(/^\+/, '')
        if (value.match(/[^0-9]/)) {
            return phoneNumber
        }
        var country,
            city,
            number = value
        if (number) {
            if (number.length > 6) {
                number =
                    number.slice(0, 3) +
                    '-' +
                    number.slice(3, 6) +
                    '-' +
                    number.slice(6, 10)
            } else if (number.length > 3) {
                number = number.slice(0, 3) + '-' + number.slice(3, 6)
            }
            return ('+1 ' + number).trim()
        } else {
            return '+1 ' + number
        }
    }

    cleanPhoneNumber(phone: string): string {
        if (!phone) return ''

        phone = phone.replace(/-/g, '')

        if (phone.includes('+')) {
            phone = phone.slice(3)
        }

        return this.filterPhoneNumber(phone)
    }
    createPatientInformation() {
        if (this.validatePatientInfoExtendedInfo()) {
            // this.toastr.warning("good.","");
            var checkObject: checkExternalIdExistsPayload = {
                externalId: '',
            }
            if (!this.__temporaryPassword) {
                this.__temporaryPassword = Math.floor(
                    100000 + Math.random() * 900000,
                )
            }
            checkObject.externalId =
                this.patientInformationObject.patientInfo.externalId

            if (checkObject.externalId && checkObject.externalId.length > 0) {
                this.createNewPatientService
                    .checkExternalIdAlreadyExistsOrNot(checkObject)
                    .then((result: any) => {
                        if (result && result.data) {
                            const checkResult: checkExternalIdExistsOrNot = {
                                data: result.data,
                                isActionSuccess: result.isActionSuccess,
                            }
                            if (
                                checkResult &&
                                checkResult.data &&
                                checkResult.data.isExternalIdAlreadyPresent
                            ) {
                                this.toastr.warning(
                                    'External Id already exists, please enter another one.',
                                )
                            } else if (
                                checkResult &&
                                checkResult.data &&
                                !checkResult.data.isExternalIdAlreadyPresent
                            ) {
                                this.patientInformationObject.patientInfo.phoneNumbers[0].phoneNumber =
                                    this.cleanPhoneNumber(
                                        this.patientInformationObject
                                            .patientInfo.phoneNumbers[0]
                                            .phoneNumber,
                                    )
                                const patientDetailsAdd = {
                                    isIndividual: true,
                                    type: 'PATIENT',
                                    displayName: `${this.patientInformationObject.patientInfo.lastName}, ${this.patientInformationObject.patientInfo.firstName}`,
                                    firstName:
                                        this.patientInformationObject
                                            .patientInfo.firstName,
                                    lastName:
                                        this.patientInformationObject
                                            .patientInfo.lastName,
                                    dateOfBirth: `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`,
                                    birthGender:
                                        this.patientInformationObject
                                            .patientInfo.birthGender,
                                    externalId:
                                        this.patientInformationObject
                                            .patientInfo.externalId,
                                    phoneNumbers: [
                                        {
                                            type: 'CELL',
                                            phoneNumber:
                                                this.patientInformationObject
                                                    .patientInfo.phoneNumbers[0]
                                                    .phoneNumber,
                                        },
                                    ],
                                    emailAddresses: [
                                        {
                                            email: this.patientInformationObject
                                                .patientInfo.emailAddresses[0]
                                                .email,
                                            type: 'HOME',
                                        },
                                    ],
                                }
                                this.createNewPatientService
                                    .createNewPatient(patientDetailsAdd)
                                    .then((resultData: any) => {
                                        if (resultData) {
                                            const result: createNewPatient = {
                                                data: resultData.data,
                                                isAlreadyPresent:
                                                    resultData.isActionSuccess,
                                            }
                                            this.toastr.success(
                                                'Member created successfully.',
                                            )
                                            if (this.showBackToSearchBtn)
                                                this.dialogRef.close({
                                                    associateWithNewPatient:
                                                        result,
                                                })
                                            else this.dialogRef.close(true)
                                        }
                                    })
                                    .catch((ex: any) => {
                                        console.log(ex)
                                        this.toastr.error(
                                            'Unknown error occurred. Please contact administrator.',
                                        )
                                    })
                            }
                        }
                    })
                    .catch((ex: any) => {
                        console.log(ex)
                        this.toastr.error(
                            'Unknown error occurred. Please contact administrator.',
                        )
                    })
            }
        }
    }

    // Only AlphaNumeric
    keyPressAlphaNumeric(event: any) {
        var inp = String.fromCharCode(event.keyCode)

        if (/^[a-zA-Z0-9]+$/.test(inp)) {
            return true;
        } else {
            event.preventDefault();
            return false;
        }
    }

    backToSearch() {
        this.dialogRef.close({ goBackToSearch: true })
    }
    onPaste(event: ClipboardEvent) {
        const pastedText = event.clipboardData?.getData('text/plain')

        if (pastedText) {
            const isNumeric = /^\d+$/.test(pastedText) // Check if pasted text is numeric

            if (!isNumeric) {
                event.preventDefault() // Prevent the paste action
            }
        }
    }
    showBackToSearchBtn: boolean = true
    ngOnInit(): void {
        if (this.data && this.data.showBackToSearch) {
            this.showBackToSearchBtn = true
        }
        if (this.data.patientDetails) {
            const patientFullName = this.data.patientDetails.patientName
                .trim()
                .split(' ')
            this.patientInformationObject.patientInfo.firstName =
                patientFullName[0]
            this.patientInformationObject.patientInfo.middleName =
                patientFullName.length > 2 ? patientFullName[1] : ''
            this.patientInformationObject.patientInfo.lastName =
                patientFullName.length > 2
                    ? patientFullName[2]
                    : patientFullName[1] || ''
            if (this.data.patientDetails.dateOfBirth) {
                const [month, day, year] =
                    this.data.patientDetails.dateOfBirth.split('/')
                this.dateOfBirthObject.dobMonth = month
                this.setDays()
                this.dateOfBirthObject.dobDay = day
                this.dateOfBirthObject.dobYear = year
                this.patientInformationObject.patientInfo.dateOfBirth =
                    this.data.patientDetails.dateOfBirth
            }
            this.patientInformationObject.patientInfo.externalId =
                this.data.patientDetails.externalId || ''
            this.patientInformationObject.patientInfo.homePhone =
                this.data.patientDetails.patientHomePhoneNumber
            this.patientInformationObject.patientInfo.cellPhone =
                this.data.patientDetails.patientPhoneNumber
            this.patientInformationObject.patientInfo.emailAddresses[0].email =
                this.data.patientDetails.patientEmail
            this.patientInformationObject.patientInfo.address.addressLine1 =
                this.data.patientDetails.addressLine1
            this.patientInformationObject.patientInfo.address.addressLine2 =
                this.data.patientDetails.addressLine2
            this.patientInformationObject.patientInfo.address.city =
                this.data.patientDetails.city
            this.patientInformationObject.patientInfo.address.postalCode =
                this.data.patientDetails.postalCode
            this.patientInformationObject.patientInfo.address.stateOrProvinceCode =
                this.data.patientDetails.stateOrProvinceCode
        }
    }
    ngOnChanges(): void {
        this.data.stateList = this.data.stateList
    }

    updatePatientDetails() {
        this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`
        this.patientInformationObject.patientInfo.address.stateOrProvinceCode =
            this.patientInformationObject.patientInfo.address
                .stateOrProvinceCode
                ? this.patientInformationObject.patientInfo.address
                      .stateOrProvinceCode
                : ''
        const editPatient = {
            firstName: this.patientInformationObject.patientInfo.firstName,
            middleName: this.patientInformationObject.patientInfo.middleName,
            lastName: this.patientInformationObject.patientInfo.lastName,
            externalId: this.patientInformationObject.patientInfo.externalId,
            dateOfBirth: this.patientInformationObject.patientInfo.dateOfBirth,
            cellPhone: this.patientInformationObject.patientInfo.cellPhone,
            homePhone: this.patientInformationObject.patientInfo.homePhone,
            email: this.patientInformationObject.patientInfo.emailAddresses[0]
                .email,
            address: this.patientInformationObject.patientInfo.address,
        }
        if (this.validUpdateRequiredFields()) {
            if (this.data.patientDetails.externalId) {
                this.loader = true
                this.createNewPatientService
                    .updatePatientDetails(editPatient, this.data.orgEntityId)
                    .subscribe({
                        next: (result: any) => {
                            this.loader = false
                            if (result) {
                                this.toastr.success(
                                    'Patient Details updated successfully.',
                                )
                                this.dialogRef.close({ success: true })
                            }
                        },
                        error: (error: any) => {
                            this.loader = false
                            this.toastr.error(
                                error.error?.message ||
                                    error?.error?.Error ||
                                    'Something went error',
                            )
                        },
                    })
            } else {
                if (
                    this.patientInformationObject.patientInfo &&
                    !this.patientInformationObject.patientInfo.externalId.trim()
                ) {
                    this.toastr.warning(`Please enter external Id`)
                    this.isValid = false
                } else {
                    this.searchByMRN(
                        {
                            target: {
                                value: this.patientInformationObject.patientInfo.externalId.trim(),
                            },
                        },
                        'save',
                    )
                }
            }
        }
    }

    searchByMRN(event?: any, saveValue?: string) {
        if (this.data.editPatient) {
            if (event) {
                this.patientInformationObject.patientInfo.externalId =
                    event.target.value
            }
            if(this.patientInformationObject.patientInfo.externalId){
                this.createNewPatientService
                .searchByMRN(
                    this.patientInformationObject.patientInfo.externalId,
                )
                .subscribe({
                    next: (result: any) => {
                        if (result && result.data) {
                            let dialogData = {
                                newValues: result.data,
                                existingValues:
                                    this.patientInformationObject.patientInfo,
                                orgEntityId: this.data.orgEntityId,
                                stateList:this.data.stateList
                            }
                            const openDialog = () => {
                                const dialogRef = this.dialog.open(
                                    PatientDetailMergeModalComponent,
                                    {
                                        disableClose: false,
                                        data: dialogData,
                                        width: '1200px',
                                    },
                                )
                                dialogRef.afterClosed().subscribe(result => {
                                    if (result.success) {
                                        this.dialogRef.close({success: true, orgEntityId: result.orgEntityId});
                                    }
                                });
                            }

                            openDialog()
                        } else {
                            if (saveValue == 'save') {
                                this.data.patientDetails.externalId =
                                    event.target.value
                                this.updatePatientDetails()
                            }else{
                                this.toastr.success("External ID/MRN does not exist. You can continue with this External Id/MRN.")
                            }
                        }
                    },
                    error: (error)=>{
                        this.toastr.error(
                            error.error?.message ||
                                error?.error?.Error ||
                                'Something went error',)
                    }
                })
            }else{
                this.toastr.warning(`Please enter External ID/MRN`)
            }
           
        }
    }

    validUpdateRequiredFields() {
        this.isValid = true
        let isLeapYear =
            parseInt(this.dateOfBirthObject.dobYear) % 100 === 0
                ? parseInt(this.dateOfBirthObject.dobYear) % 400 === 0
                : parseInt(this.dateOfBirthObject.dobYear) % 4 === 0

        if (
            this.patientInformationObject.patientInfo &&
            (!this.patientInformationObject.patientInfo.externalId ||
                !this.patientInformationObject.patientInfo.externalId?.trim())
        ) {
            this.toastr.warning(`Please enter external Id`)
            this.isValid = false
        } else if (
            this.patientInformationObject.patientInfo &&
            (!this.patientInformationObject.patientInfo.firstName ||
                !this.patientInformationObject.patientInfo.firstName?.trim())
        ) {
            this.toastr.warning(`Please enter First Name`)
            this.isValid = false
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.firstName.length > 60
        ) {
            this.toastr.warning(`First name should be less than 60 characters`)
            this.isValid = false
        }else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.middleName.length > 60
        ) {
            this.toastr.warning(`Middle name should be less than 60 characters`)
            this.isValid = false
        }
        else if (
            this.patientInformationObject.patientInfo &&
            (this.patientInformationObject.patientInfo.middleName ||
                this.patientInformationObject.patientInfo.middleName?.trim()) &&
            !this.nameRegex.test(
                this.patientInformationObject.patientInfo.middleName,
            )
        ) {
            this.toastr.warning(`Please enter valid Middle Name`)
            this.isValid = false
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.lastName.length > 60
        ) {
            this.toastr.warning(`Last name should be less than 60 characters`)
            this.isValid = false
        } else if (
            this.patientInformationObject.patientInfo &&
            (this.patientInformationObject.patientInfo.firstName ||
                this.patientInformationObject.patientInfo.firstName?.trim()) &&
            !this.nameRegex.test(
                this.patientInformationObject.patientInfo.firstName,
            )
        ) {
            this.toastr.warning(`Please enter valid First Name`)
            this.isValid = false
        } else if (
            this.patientInformationObject.patientInfo &&
            (!this.patientInformationObject.patientInfo.lastName ||
                !this.patientInformationObject.patientInfo.lastName?.trim())
        ) {
            this.toastr.warning(`Please enter Last Name`)
            this.isValid = false
        } else if (
            this.patientInformationObject.patientInfo &&
            (this.patientInformationObject.patientInfo.lastName ||
                this.patientInformationObject.patientInfo.lastName?.trim()) &&
            !this.nameRegex.test(
                this.patientInformationObject.patientInfo.lastName,
            )
        ) {
            this.toastr.warning(`Please enter valid Last Name`)
            this.isValid = false
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.cellPhone &&
            (this.patientInformationObject.patientInfo.cellPhone.length !==
                15 ||
                !this.phoneRegex.test(
                    this.patientInformationObject.patientInfo.cellPhone,
                ))
        ) {
            this.toastr.warning(`Please enter valid cell Number`)
            this.isValid = false
        } else if (
            this.patientInformationObject.patientInfo &&
            !this.patientInformationObject.patientInfo.cellPhone
        ) {
            this.toastr.warning(`Please enter cell phone`)
            this.isValid = false
        } else if (
            this.patientInformationObject.patientInfo &&
            (!this.patientInformationObject.patientInfo.emailAddresses[0]
                .email ||
                !this.patientInformationObject.patientInfo.emailAddresses[0].email?.trim())
        ) {
            this.toastr.warning(`Please enter email address`)
            this.isValid = false
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.homePhone &&
            (this.patientInformationObject.patientInfo.homePhone.length !==
                15 ||
                !this.phoneRegex.test(
                    this.patientInformationObject.patientInfo.homePhone,
                ))
        ) {
            this.toastr.warning(`Please enter valid home Number`)
            this.isValid = false
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.emailAddresses[0] &&
            this.patientInformationObject.patientInfo.emailAddresses[0].email &&
            !this.emailRegex.test(
                this.patientInformationObject.patientInfo.emailAddresses[0]
                    .email,
            )
        ) {
            this.toastr.warning(`Enter a valid Confidential Email`)
            this.isValid = false
        } else if (
            this.patientInformationObject.patientInfo &&
            this.patientInformationObject.patientInfo.emailAddresses[0].email
                .length > 100
        ) {
            this.toastr.warning(
                `Email address should be less than 100 characters`,
            )
            this.isValid = false
        } else if (this.dateOfBirthObject && !this.dateOfBirthObject.dobMonth) {
            this.toastr.warning(`Please enter your  DOB Month`)
            this.isValid = false
        } else if (this.dateOfBirthObject && !this.dateOfBirthObject.dobDay) {
            this.toastr.warning(`Please enter your  DOB Day`)
            this.isValid = false
        } else if (this.dateOfBirthObject && !this.dateOfBirthObject.dobYear) {
            this.toastr.warning(`Please enter your  DOB Year`)
            this.isValid = false
        } else if (
            this.isValid &&
            this.dateOfBirthObject.dobMonth &&
            this.dateOfBirthObject.dobDay &&
            this.dateOfBirthObject.dobYear
        ) {
            if (
                this.dateOfBirthObject.dobMonth < 10 &&
                this.dateOfBirthObject.dobDay >= 10
            ) {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`
            } else if (
                this.dateOfBirthObject.dobDay < 10 &&
                this.dateOfBirthObject.dobMonth >= 10
            ) {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`
            } else if (
                this.dateOfBirthObject.dobDay < 10 &&
                this.dateOfBirthObject.dobMonth < 10
            ) {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`
            } else {
                this.patientInformationObject.patientInfo.dateOfBirth = `${this.dateOfBirthObject.dobMonth}/${this.dateOfBirthObject.dobDay}/${this.dateOfBirthObject.dobYear}`
            }
            var date = moment(
                this.patientInformationObject.patientInfo.dateOfBirth,
            )
            if (date.isValid()) {
                var currentDateTime = new Date()
                var expirationDateTime = new Date(
                    this.patientInformationObject.patientInfo.dateOfBirth,
                )
                if (expirationDateTime.getTime() > new Date().getTime()) {
                    this.toastr.warning(
                        "Birth date can't be greater than or equal to the current date",
                    )
                    this.isValid = false
                } else if (+this.dateOfBirthObject.dobYear < 1900) {
                    this.toastr.warning(
                        'Birth year should be greater than or equal to 1900.',
                    )
                    this.isValid = false
                } else if (
                    expirationDateTime.getMonth() ===
                        currentDateTime.getMonth() &&
                    expirationDateTime.getFullYear() ===
                        currentDateTime.getFullYear() &&
                    expirationDateTime.getDate() === currentDateTime.getDate()
                ) {
                    this.toastr.warning(
                        "Birth date can't be greater than or equal to the current date",
                    )
                    this.isValid = false
                } else if (
                    this.dateOfBirthObject.dobMonth.toString() == '02' &&
                    this.dateOfBirthObject.dobDay > 28 &&
                    !isLeapYear
                ) {
                    this.toastr.warning('Invalid birth date')
                    this.isValid = false
                } else {
                    this.isValid = true
                }
            } else {
                this.toastr.warning('Date of birth is invalid')
                this.isValid = false
            }
        }

        return this.isValid
    }
}
